import ScrollBooster from 'scrollbooster';

// "focus" block
document.addEventListener('DOMContentLoaded', function () {
  class BlockFocus extends HTMLElement {
    constructor() {
      super();
      // elements
      this.scroller = this.querySelector('.js-focus__scroller');
      this.boostedScroller = null;
    }
    connectedCallback() {
      this.onLoad();
    }
    disconnectedCallback() {
      if (this.boostedScroller) {
        this.boostedScroller.destroy();
      }
    }
    onLoad() {
      this.attachScroller();
    }
    attachScroller() {
      if (!this.scroller) return;
      this.boostedScroller = new ScrollBooster({
        viewport: this.scroller,
        scrollMode: 'native',
        direction: 'horizontal',
        bounce: false,
        textSelection: true
      });
    }
  }
  customElements.define('block-focus', BlockFocus);
});